import React, { ReactElement } from 'react'
import { StyleSheet, View } from 'react-native'

interface ContainerProps {
  children: ReactElement | ReactElement[]
}

export default function ({ children } : ContainerProps) {
  return (
    <View style={styles.container}>{ children }</View>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    padding: 20,
    paddingBottom: 40,
    width: '100%',
  },
})
